import styled from '@emotion/styled';
import { fontSizes, gutterSizes, colors, boxSizes } from '../base/theme';

export const Container = styled.div<{ type: 'srp' | 'vip', isMobile?: boolean, pageType?: string }>`
    display: flex;
    justify-content: ${props => props.type === 'vip' && props.isMobile ? 'flex-start' : 'center'};
    align-items: center;
    flex-direction: ${props => props.type === 'srp' && !props.isMobile ? 'column' : 'row'};
    gap: ${props => props.type === 'srp' ? gutterSizes.small : gutterSizes.base};
    margin-top: ${gutterSizes.base};
    padding: ${props => props.type === 'vip' && !props.isMobile ? gutterSizes.base : '0'};

    ${props => props.type === 'srp' && props.isMobile && `
        background-color: ${colors.surface};
        border-radius: ${boxSizes.borderRadius4};
        padding: ${gutterSizes.xsmall} ${gutterSizes.base};
        width: fit-content;
    `}

    &:hover {
        cursor: pointer;
    }
`;

export const ScoreRow = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    height: 16px;
`;

export const StarIcon = styled.div`
    display: flex;
    align-items: center;
    
    svg {
        width: 17px;
        height: 16px;
        fill: ${colors.navy};
        stroke: ${colors.navy};
    }
`;

export const Score = styled.span`
    color: ${colors.navy};
    line-height: 1.2;
    height: 16px;
`;

export const ReviewCount = styled.span<{ type: 'srp' | 'vip' }>`
    font-size: ${props => props.type === 'srp' ? fontSizes.msmall : fontSizes.small};
    color: ${props => props.type === 'srp' ? colors.navy : colors.fgButtonDisabled};
    line-height: 1;
<<<<<<< HEAD
=======
    position: relative;
    top: 1px;
>>>>>>> master
`;
